module.exports = __webpack_public_path__ + "img/logo-demo-knowledge.bd660e0a.png";